<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex mt-2 pl-3 align-center justify-center>
          <div class="headline">Role</div>

          <p>Drzewo ról użytkownika</p>
        </v-flex>
      </v-layout>

      <v-treeview ref="treeview" :items="tree" :open-all="true">
        <template v-slot:append="{ item }">
          <div>
            <check-permission
              v-if="item.isAssigned"
              joinType="OR"
              entityType="profile"
              :entityId="userId"
              :permissions="['USER.ROLE_MANAGE']"
            >
              <v-btn icon flat color="error" @click="idToDelete = item.id">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </check-permission>

            <check-permission
              v-if="!item.isAssigned"
              joinType="OR"
              entityType="profile"
              :entityId="userId"
              :permissions="['USER.ROLE_MANAGE']"
            >
              <v-btn icon flat color="primary" @click="idToAdd = item.id">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </check-permission>
          </div>
        </template>

        <template v-slot:label="{ item }">
          <div class="v-treeview-node__label">
            {{ item.name }}
            <small v-if="item.isAssigned">(Posiadana)</small>
          </div>
        </template>
      </v-treeview>
    </material-card>

    <material-dialog
      title="Potwierdź usunięcie"
      text="Czy napewno chcesz usunąć użytkownikowi rolę?"
      :show="!!idToDelete"
      :id="idToDelete"
      @close="hideDialog"
      @confirm="remove"
    ></material-dialog>

    <material-dialog
      title="Potwierdź dodanie"
      text="Czy napewno chcesz dodać rolę do użytkownika"
      :show="!!idToAdd"
      :id="idToAdd"
      @close="hideDialog"
      @confirm="add"
    ></material-dialog>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';
import { SessionStorage } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';

// @vuese
// Wyświetlanie drzewa ról danego użytkownika
// @group Roles
export default {
  components: {
    MaterialCard,
    MaterialDialog
  },
  data() {
    return { idToDelete: undefined, idToAdd: undefined };
  },
  computed: {
    ...mapState({
      tree(state) {
        const userRoles = state.profiles.userRole.list;

        const roles = state.roles.list.map(role => ({
          ...role,
          isAssigned: userRoles.find(userRole => userRole.id === role.id)
        }));

        return roles.reduce((roots, role) => {
          if (!!role.parent) {
            const parent = roles.find(r => r.id === role.parent.id);
            parent ? this.addToParent(parent, role, roles) : roots.push(role);
          } else {
            roots.push(role);
          }
          return roots;
        }, []);
      }
    }),
    partnerId() {
      return sessionStorage.getItem(SessionStorage.PARTNER_ID);
    },
    userId() {
      return this.$route.params.employeeId ? this.$route.params.employeeId : this.$route.params.id;
    }
  },
  methods: {
    // @vuese
    // Usuwa rolę użytkownikowi
    remove(roleId) {
      this.$store.dispatch('profiles/userRole/remove', this.roleConfig(roleId));
    },
    // @vuese
    // Dodaje rolę do użytkownika
    add(roleId) {
      this.$store.dispatch('profiles/userRole/add', this.roleConfig(roleId));
    },
    // @vuese
    // Konfiguracja relacji roli
    roleConfig(roleId) {
      const roleConfig = { roleId, userId: this.userId };
      if (this.partnerId) {
        roleConfig.entityType = 'partner';
        roleConfig.entityId = this.partnerId.toString();
      }
      return roleConfig;
    },
    // @vuese
    // Zamyka dialog
    hideDialog() {
      this.idToDelete = undefined;
      this.idToAdd = undefined;
    },
    // @vuese
    // Ustawia rolę jako dziecko
    addToParent(parent, role, roles) {
      if (parent.children) {
        parent.children.push(role);
      } else {
        parent.children = [role];
      }
    }
  }
};
</script>